module.exports = __webpack_public_path__ + "img/logo_side.8007b14a.png";